let model = {};

model.dataForm = {
    id: undefined, // optional Mã điểm đến
    loai: undefined, // required, enum(hotel, restaurant, entertainment, ticket, yellow_page_place) Loại dịch vụ của đơn vị cung cấp
    ly_do_tu_choi: undefined, // optional Lý do từ chối
    du_lieu_khai_bao: // optional Dữ liệu khai báo khi đăng ký điểm đến
    {},
    duyet: // optional
    {
        duoc_duyet: undefined, // optional Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
        thoi_diem_duyet: undefined, // optional Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
        nguoi_duyet_id: undefined, // optional Mã người duyệt
    },
    luu_tru: // optional Lưu trú
    {
        so_sao: undefined, // optional, min: 0, max: 5 Số sao
    },

    am_thuc: // optional Ẩm thực
    {
        dich_vu: undefined, // optional
    },

    ve_dien_tu: // optional Vé điện tử
    {
        loai: undefined, // optional, enum(air_plain_ticket, show_ticket) Loại vé điện tử. air_plain_ticket: Vé máy bay, show_ticket: Vé nghệ thuật
    },
    diem_den: {}, // optional Điểm đến
    giai_tri: {}, // optional Giải trí
    thoi_gian_tao: undefined, // required
    nguoi_tao: undefined, // required
    thoi_gian_sua_cuoi: undefined, // required Thời gian lần sửa bản ghi cuối cùng
    nguoi_sua_cuoi: undefined, // required Mã người sửa cuối
};


// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhGiayTo: {
            limit: null,
            accept: "",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },
};





export default model;
